import { useState } from "react";
import { Layout } from "antd";
import DepartmentType from "./DepartmentType";
import DepartmentTable from "./DepartmentTable";
import styles from "./index.module.less";
function DepartmentIndex() {
  const [departmentType, setDepartmentType] = useState("all");
  return (
    <Layout className={styles.departmentIndex}>
      <Layout.Sider className="department-type-container">
        <DepartmentType
          departmentType={departmentType}
          setDepartmentType={setDepartmentType}
        />
      </Layout.Sider>
      <Layout.Content className="department-list-container">
        <DepartmentTable departmentType={departmentType} />
      </Layout.Content>
    </Layout>
  );
}

export default DepartmentIndex;
